import { Download, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ExportBarProps {
  onDownloadCSV: () => void;
  onPrint: () => void;
}

export function ExportBar({ onDownloadCSV, onPrint }: ExportBarProps) {
  return (
    <div className="flex items-center gap-2 print:hidden">
      <Button variant="outline" size="sm" onClick={onDownloadCSV}>
        <Download className="h-4 w-4" />
        Download CSV
      </Button>
      <Button variant="outline" size="sm" onClick={onPrint}>
        <Printer className="h-4 w-4" />
        Print / PDF
      </Button>
    </div>
  );
}
